import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Task } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  allocateResources(request: Boundaries["allocateResources"]["request"]): void;
}

function useAllocateResources(task: Identifiable<Task>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAllocateResourcesRequestPending(task),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAllocateResourcesRequestSuccess(task),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAllocateResourcesRequestFailure(task),
    ),
    allocateResources: core.allocateResources,
  };
}

export { useAllocateResources };
